const stats = [
  { value: "500+", label: "Przeanalizowanych twórców" },
  { value: "12×", label: "Aktualizacji miesięcznie" },
  { value: "30+", label: "Kategorii danych" },
  { value: "200+", label: "Zadowolonych agencji" },
];

const checks = [
  "Setki analizowanych twórców",
  "Regularne aktualizacje bazy",
  "Narzędzia zoptymalizowane dla agencji",
  "Edukacyjna baza wiedzy",
];

export default function TrustSection() {
  return (
    <section className="relative w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Zaufaj sprawdzonemu rozwiązaniu
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            USFans Spreadsheet to narzędzie, któremu zaufały już setki agencji na całym świecie.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-14">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-4">
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Trust checks */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
          {checks.map((check) => (
            <div key={check} className="flex items-center gap-3 p-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className="ri-check-line text-sm text-accent-600"></i>
              </div>
              <span className="text-sm text-foreground-700">{check}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}